import { Kpi, KpiGrid } from '@/components/ui'
import type { AtsDashboard } from '../types'

const ITEMS: { key: keyof AtsDashboard; label: string }[] = [
  { key: 'vagas_abertas', label: 'Vagas abertas' },
  { key: 'candidaturas_mes', label: 'Candidaturas (mês)' },
  { key: 'candidatos_ativos', label: 'Candidatos ativos' },
  { key: 'em_entrevista', label: 'Em entrevista' },
  { key: 'ofertas', label: 'Ofertas' },
  { key: 'contratados_mes', label: 'Contratados (mês)' },
  { key: 'taxa_conversao', label: 'Conversão %' },
  { key: 'score_medio_ia', label: 'Score IA médio' },
]

export function KpiStrip({ data }: { data: AtsDashboard }) {
  return (
    <KpiGrid>
      {ITEMS.map((item) => {
        const raw = data[item.key]
        const value = typeof raw === 'number' ? raw : 0
        return (
          <Kpi
            key={item.key}
            label={item.label}
            value={
              item.key.includes('taxa') || item.key.includes('score')
                ? value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })
                : value.toLocaleString('pt-BR')
            }
          />
        )
      })}
    </KpiGrid>
  )
}
